module.exports = __webpack_public_path__ + "media/icons/featured-nav-left-5109ac0c.png";